// extracted by mini-css-extract-plugin
export default {"ProjectGallery":"ProjectGallery_ProjectGallery__RBn3z","gallery_image_wrap":"ProjectGallery_gallery_image_wrap__mFN7g"};